module.exports = ".table-mapeamentos {\n  background: #fff;\n}\n\n.icon-list {\n  cursor: pointer;\n}"